
import React from 'react';
import Grid from '@mui/material/Grid2';
import {
    Box,
    Button,
} from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import './Policy.css'
import './CustomCSS.scss'
import '../../assets/styles/vendor.css'
import { useSearchParams, useNavigate, useParams } from "react-router-dom";
import { useStoreActions } from 'easy-peasy';
import PageLoader from '../../components/pageloader/pageLoader';
import MetaSection from './components/MetaSection';
import PolicyText from './components/PolicyText';
import ClinicalCriteria from './components/ClinicalCriteria';
import Attachments from './components/Attachments';
import Questionnaire from './components/Questionnaire';
import ProcedureCodes from './components/ProcedureCodes';
import References from './components/References';
import PolicyHistory from './components/PolicyHistory';
import RequiredDocuments from './components/RequiredDocuments';
import PolicyTags from './components/PolicyTags';

const Policy = (props) => {
    const { orgId, id} = useParams(); // Getting the segment from the route

    const { vid = "active" } = useParams();

    const [policyData, setPolicyData] = React.useState({});
    const [openLoader, setOpenLoader] = React.useState(false);

    const getParamCaseInsensitive = (params, keyToFind) => {
        for (const [key, value] of params.entries()) {
            if (key.toLowerCase() === keyToFind.toLowerCase()) {
                return value;
            }
        }
        return null;
    };

    const navigate = useNavigate();

    const policyAction = useStoreActions((actions) => actions.policy);

    const [searchParams] = useSearchParams();
    const lob = getParamCaseInsensitive(searchParams, "lob");
    const accessToken = getParamCaseInsensitive(searchParams, "access_token");
    const theme = getParamCaseInsensitive(searchParams, "theme");

    React.useEffect(() => {
        const fetchPolicyData = async () => {
            setOpenLoader(true);
            try {
                const response = await policyAction.getPolicyContent({ orgId, policyId: id, vid, accessToken });
                setPolicyData(response?.data?.data);
            } catch (error) {
                if (error?.response?.status === 404) {
                    navigate('/not-found');
                }
            } finally {
                setOpenLoader(false);
            }
        };

        fetchPolicyData();
    }, [orgId, id, vid, accessToken, navigate, policyAction]);
    

    React.useEffect(() => {
        if (lob && policyData && policyData?.procedures && policyData?.procedures?.length>0) {
            let filteredPC = policyData?.procedures?.filter(i=>i?.lob_title?.toLowerCase()===lob?.toLowerCase());
            if (filteredPC.length===0) {
                navigate('/not-found');
            }
        }
    }, [policyData, lob, navigate]);


    return (
        <Box component="section" className="headerBox" id={`tenantId-${orgId}`} style={{minHeight:'75vh'}}>
            <Grid container className="container">
                <Grid item size={12} className={`policy-template-content ${theme && theme.toLowerCase()==='v2' ? 'theme-v2' : '' } `}>
                    
                    <div>
                        <Button onClick={() => {
                            window.print();
                        }} style={{color: '#af68af', fontSize: '14px', textTransform: 'none', fontFamily: '"open_sanssemibold"'}}><PrintIcon style={{marginRight:'2px'}}/> Print</Button>
                    </div>

                    <div className="contentWrapper">
                        <MetaSection policyShortName={id} policyData={policyData} />
                    </div>

                    <div className="contentWrapper">
                        <ClinicalCriteria policyData={policyData} />
                    </div>

                    <div className="contentWrapper">
                        <PolicyText policyData={policyData} />
                    </div>

                    <div className="contentWrapper">
                        <ProcedureCodes lob={lob} policyData={policyData} />
                    </div>

                    <div className="contentWrapper">
                        <Attachments policyData={policyData} setOpenLoader={setOpenLoader} />
                    </div>

                    <div className="contentWrapper">
                        <References policyData={policyData} />
                    </div>

                    <div className="contentWrapper">
                        <PolicyTags policyData={policyData} />
                    </div>

                    <div className="contentWrapper">
                        <PolicyHistory policyData={policyData} />
                    </div>

                    <div className="contentWrapper">
                        <Questionnaire policyData={policyData} setOpenLoader={setOpenLoader} />
                    </div>

                    <div className="contentWrapper">
                        <RequiredDocuments policyData={policyData} />
                    </div>

                    {/* Loader Overlay */}
                    <PageLoader openLoader={openLoader} isGlobal={true} />
                
    
                </Grid>
            </Grid>
        </Box>
    )
}

export default Policy;